/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      email
      developmentPlans {
        items {
            id
            name
            version
            createdAt
            updatedAt
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        email
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDevelopmentPlan = /* GraphQL */ `
  query GetDevelopmentPlan($id: ID!) {
    getDevelopmentPlan(id: $id) {
      id
      name
      version
      userID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDevelopmentPlans = /* GraphQL */ `
  query ListDevelopmentPlans(
    $filter: ModelDevelopmentPlanFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDevelopmentPlans(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        version
        userID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const developmentPlansByUserIDAndId = /* GraphQL */ `
  query DevelopmentPlansByUserIDAndId(
    $userID: ID!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDevelopmentPlanFilterInput
    $limit: Int
    $nextToken: String
  ) {
    developmentPlansByUserIDAndId(
      userID: $userID
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        version
        userID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
